<dcr-top-app-bar class="p-b-2xs">
  <a href="/" slot="tiny-logo" class="dk-logo"><dcr-logo logo="diekeure:square:full"></dcr-logo></a>

  <ng-container *ngIf="mobile$ | async; else full">
    <div class="relative" slot="actions">
      <dcr-inline-icon-button id="btn-menu" icon="portal:menu"></dcr-inline-icon-button>
      <dcr-menu anchor="btn-menu" [attr.has-overflow]="!!(headerActions$ | async)">
        <dcr-menu-item
          *ngFor="let link of headerLinks"
          type="link"
          [attr.href]="link.route.url"
          [leadingIcon]="link.icon"
          [label]="link.label"
        ></dcr-menu-item>
        <dcr-divider></dcr-divider>
        <dcr-sub-menu *ngIf="headerActions$ | async as headerActions" preferred-direction="start">
          <dcr-menu-item slot="item" label="Aanmelden"></dcr-menu-item>
          <dcr-menu slot="menu">
            <dcr-menu-item
              *ngFor="let child of headerActions.children"
              [type]="child.href ? 'link' : 'button'"
              [label]="child.label"
              [leadingIcon]="child.icon"
              [attr.href]="child.href ? child.href : undefined"
              (click)="child.action && child.action()"
            ></dcr-menu-item>
          </dcr-menu>
        </dcr-sub-menu>
      </dcr-menu>
    </div>
  </ng-container>

  <ng-template #full>
    <div class="navigation-bar" slot="actions">
      <a
        class="bar-item"
        [attr.id]="'link' + link.id"
        *ngFor="let link of headerLinks"
        [attr.href]="link.route.url"
        tabindex="0"
      >
        <span class="icon-container">
          <dcr-icon size="l" [icon]="link.icon"></dcr-icon>
          <dcr-state-layer [attr.for]="'link' + link.id"></dcr-state-layer>
          <dcr-focus-ring [attr.for]="'link' + link.id"></dcr-focus-ring>
        </span>
        <span class="label">{{ link.label }}</span>
      </a>

      <div class="login-actions" *ngIf="headerActions$ | async as headerActions">
        <dcr-filled-button
          id="btn-login"
          [label]="headerActions.label"
          trailing-icon="portal:arrow-drop-down"
          data-cy="btn-header-dropdown-open"
        ></dcr-filled-button>
        <dcr-menu anchor="btn-login">
          <dcr-menu-item
            *ngFor="let child of headerActions.children"
            [type]="child.href ? 'link' : 'button'"
            [label]="child.label"
            [leadingIcon]="child.icon"
            [attr.href]="child.href ? child.href : undefined"
            (click)="child.action && child.action()"
            data-cy="btn-dropdown-action"
          ></dcr-menu-item>
        </dcr-menu>
      </div>
    </div>
  </ng-template>
</dcr-top-app-bar>
